var map = {
	"./About": 41,
	"./About.jsx": 41,
	"./Articles/Article": 42,
	"./Articles/Article.jsx": 42,
	"./Articles/ArticleCard": 25,
	"./Articles/ArticleCard.jsx": 25,
	"./Articles/ArticleLists": 26,
	"./Articles/ArticleLists.jsx": 26,
	"./Articles/Main": 43,
	"./Articles/Main.jsx": 43,
	"./BusinessInfo": 28,
	"./BusinessInfo.jsx": 28,
	"./Contact": 44,
	"./Contact.jsx": 44,
	"./FAQ": 45,
	"./FAQ.jsx": 45,
	"./Footer": 57,
	"./Footer.jsx": 57,
	"./Founders": 22,
	"./Founders.jsx": 22,
	"./Hero": 16,
	"./Hero.jsx": 16,
	"./InstagramFeed": 32,
	"./InstagramFeed.jsx": 32,
	"./Locations": 54,
	"./Locations.jsx": 54,
	"./Main": 55,
	"./Main.jsx": 55,
	"./Mission": 23,
	"./Mission.jsx": 23,
	"./NavLayout": 56,
	"./NavLayout.jsx": 56,
	"./NavLink": 12,
	"./NavLink.jsx": 12,
	"./Products": 30,
	"./Products.jsx": 30,
	"./Sanity/ContentTypes/TypeHandler": 24,
	"./Sanity/ContentTypes/TypeHandler.jsx": 24,
	"./Sanity/Parser": 27,
	"./Sanity/Parser.jsx": 27,
	"./Sanity/sanityClient": 18,
	"./Sanity/sanityClient.jsx": 18,
	"./Story": 21,
	"./Story.jsx": 21,
	"./Testimonials": 31,
	"./Testimonials.jsx": 31,
	"./WhyOurCoffee": 29,
	"./WhyOurCoffee.jsx": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;